import { createStore } from 'vuex'

export default createStore({
  state: {
    user: {
      nickname: '',
      department: '',
      user_id: 0,
      user_role: 0,
    }
  },
  getters: {
  },
  mutations: {
    setLogin: (state, user) => {
      state.user = user
    } 
  },
  actions: {
  },
  modules: {
  }
})
